<template>
    <div id="contenedor-main-contrato-reporte-actividades">
      <!-- ToolBar -->
      <!-- <tool-bar
        v-on:nuevoReporte="nuevoReporte">
      </tool-bar> -->
      <!-- Listado -->
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="listado">
          </listado>
        </v-card-text>
      </v-card>
      <!-- Registrar nueva actividad -->
      <v-dialog
        v-model="mostrarRegistrarActividad"
        width="650"
        persistent>
        <registrar-actividad
          :id-contrato="$route.params.idContrato"
          :tipo="tipoActividad"
          v-on:cerrar="cerrarVentana">
        </registrar-actividad>
      </v-dialog>
      <!-- Editar actividad -->
      <v-dialog
        v-if="estaActividad"
        v-model="mostrarEditarActividad"
        width="650"
        persistent>
        <editar-actividad
          :actividadContratoEditar="estaActividad"
          v-on:cerrar="cerrarVentana">
        </editar-actividad>
      </v-dialog>
      <!-- Eliminar Actividad -->
      <v-dialog
      v-if="estaActividad"
      v-model="mostrarEliminarActividad"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-actividad
          :contratoActividadEliminar="estaActividad"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
    <v-dialog
      v-model="mostrarCarrucelImagenes"
      width="550">
      <v-card>
        <v-card-text>
          <imagen-carousels
            :imagenes="imagenes"
            v-on:cerrar="mostrarCarrucelImagenes = !mostrarCarrucelImagenes">
          </imagen-carousels>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import CONTRATO_ACTIVIDADES from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividades.gql';
import RegistrarActividad from '@/components/administracion/contratos/contrato/actividades/Agregar.vue';
import EditarActividad from '@/components/administracion/contratos/contrato/actividades/Editar.vue';
import EliminarActividad from '@/components/administracion/contratos/contrato/actividades/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';
import ImagenCarousels from '@/components/ImagenCarousels.vue';

export default {
  name: 'MainContratoReporteActividades',
  components: {
    RegistrarActividad,
    EditarActividad,
    EliminarActividad,
    Listado,
    ImagenCarousels,
  },
  data() {
    return {
      mostrarRegistrarActividad: false,
      mostrarEditarActividad: false,
      mostrarEliminarActividad: false,
      mostrarCarrucelImagenes: false,
      estaActividad: null,
      tipoActividad: 0,
      imagenes: [],
    };
  },
  apollo: {
    contratoActividades: {
      query: CONTRATO_ACTIVIDADES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    nuevoReporte() {
      this.mostrarRegistrarActividad = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarActividad = false;
      this.mostrarEditarActividad = false;
      this.mostrarEliminarActividad = false;
      this.estaActividad = null;
      this.tipoActividad = 0;
    },
  },
  computed: {
    listado() {
      if (!this.contratoActividades) return [];
      return this.contratoActividades
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
  mounted() {
    eventBus.$on('mostrar-imagenes-actividad-contrato', (imagenes) => {
      this.imagenes = imagenes;
      this.mostrarCarrucelImagenes = true;
    });
    eventBus.$on('registrar-actividad-contrato', (tipo) => {
      this.tipoActividad = tipo;
      this.mostrarRegistrarActividad = true;
    });
    eventBus.$on('editar-actividad-contrato', (actividadContrato) => {
      this.estaActividad = actividadContrato;
      this.mostrarEditarActividad = true;
    });
    eventBus.$on('eliminar-actividad-contrato', (actividadContrato) => {
      this.estaActividad = actividadContrato;
      this.mostrarEliminarActividad = true;
    });
  },
};
</script>

<style lang="scss">

</style>
